









import Vue from "vue";
export default Vue.extend({
	name: "YTChip",
	props: {
		tag: {
			type: String,
			default: "router-link"
		},
		to: {
			default: "#",
			type: String
		},
		text: {
			required: true,
			type: String
		}
	}
});
